// extracted by mini-css-extract-plugin
module.exports = {"segment":"BuilderSegment_segment__EwpO4","disabled":"BuilderSegment_disabled__3cqzy"};